import { render } from "./ComboView.vue?vue&type=template&id=4b851035"
import script from "./ComboView.vue?vue&type=script&lang=js"
export * from "./ComboView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__